"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPEN_GRAPH_IMAGE_MIME_TYPE = exports.OPEN_GRAPH_DESCRIPTION_MAX_LENGTH = exports.OPEN_GRAPH_IMAGE_HEIGHT = exports.OPEN_GRAPH_IMAGE_WIDTH = void 0;
exports.getOpenGraphImage = getOpenGraphImage;
exports.getOpenGraphDescription = getOpenGraphDescription;
exports.getOpenGraphLocale = getOpenGraphLocale;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const open_graph_1 = require("../internationalization/locales/open-graph");
const string_1 = require("./string");
exports.OPEN_GRAPH_IMAGE_WIDTH = 1200;
exports.OPEN_GRAPH_IMAGE_HEIGHT = 630;
exports.OPEN_GRAPH_DESCRIPTION_MAX_LENGTH = 160;
exports.OPEN_GRAPH_IMAGE_MIME_TYPE = "image/jpeg";
const CLOUDINARY_UPLOAD_SEGMENT = "/image/upload/";
const COVER_TRANSFORMATION = `c_fill,g_auto,f_jpg,q_auto,w_${exports.OPEN_GRAPH_IMAGE_WIDTH},h_${exports.OPEN_GRAPH_IMAGE_HEIGHT}`;
const CONTAIN_TRANSFORMATION = `c_pad,b_auto,f_jpg,q_auto,w_${exports.OPEN_GRAPH_IMAGE_WIDTH},h_${exports.OPEN_GRAPH_IMAGE_HEIGHT}`;
function getOpenGraphImage(url, options = {}) {
    if (!url) {
        return null;
    }
    const transformation = options.fit === "contain" ? CONTAIN_TRANSFORMATION : COVER_TRANSFORMATION;
    const uploadIndex = url.indexOf(CLOUDINARY_UPLOAD_SEGMENT);
    if (!url.includes("res.cloudinary.com") || uploadIndex === -1) {
        return { url };
    }
    if (url.includes(transformation)) {
        return {
            url,
            width: exports.OPEN_GRAPH_IMAGE_WIDTH,
            height: exports.OPEN_GRAPH_IMAGE_HEIGHT,
            mimeType: exports.OPEN_GRAPH_IMAGE_MIME_TYPE,
        };
    }
    const insertAt = uploadIndex + CLOUDINARY_UPLOAD_SEGMENT.length;
    return {
        url: `${url.slice(0, insertAt)}${transformation}/${url.slice(insertAt)}`,
        width: exports.OPEN_GRAPH_IMAGE_WIDTH,
        height: exports.OPEN_GRAPH_IMAGE_HEIGHT,
        mimeType: exports.OPEN_GRAPH_IMAGE_MIME_TYPE,
    };
}
function truncateAtWordBoundary(text, maxLength) {
    if (text.length <= maxLength) {
        return text;
    }
    const slice = text.slice(0, maxLength - 1);
    const lastSpaceIndex = slice.lastIndexOf(" ");
    const truncated = lastSpaceIndex > 0 ? slice.slice(0, lastSpaceIndex) : slice;
    return `${truncated.trimEnd()}…`;
}
function getOpenGraphDescription(input) {
    if (!input) {
        return "";
    }
    const withoutTags = (0, sanitize_html_1.default)(input, { allowedTags: [] });
    const decoded = (0, string_1.decodeHtmlEntities)(withoutTags);
    const normalized = decoded.replace(/[\s\u00A0]+/g, " ").trim();
    return truncateAtWordBoundary(normalized, exports.OPEN_GRAPH_DESCRIPTION_MAX_LENGTH);
}
function getOpenGraphLocale(isoLocale) {
    if (!isoLocale) {
        return "en_US";
    }
    if (isoLocale.includes("-")) {
        const [language, region] = isoLocale.split("-");
        return `${language.toLowerCase()}_${region.toUpperCase()}`;
    }
    return open_graph_1.DEFAULT_OPEN_GRAPH_LOCALES_BY_LANGUAGE[isoLocale.toLowerCase()] ?? "en_US";
}
